var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('TheHeader'),_vm._m(0),_c('TheFooter')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"faq-bg"},[_c('h1',{staticClass:"text-6xl font-bold pt-56 text-center uppercase text-white"},[_vm._v(" Frequently Asked Questions ")])])
}]

export { render, staticRenderFns }